module.exports = __webpack_public_path__ + "static/DSC_9420-d9607a705978e1df8077541dc428bc6c.jpg";